<template>
  <div>
    <v-container>
      <v-card>
        <v-card-title> Promo Codes </v-card-title>
        <v-card-text>
          <v-btn color="primary" @click="showModal = true">Add Promo Code</v-btn>
          <br /><br />
          <v-data-table :headers="headers" :items="promoCodes" @click:row="editPromoCode" class="elevation-1">
            <!-- ... other code ... -->
            <template v-slot:item.status="{ item }">
                            <v-chip :color="getChipColor(item.status)" small>{{ item.status }}</v-chip>
                        </template>
            <template v-slot:item.start_date="{ item }">
              {{ formatDate(item.start_date) }}
            </template>
            <template v-slot:item.end_date="{ item }">
              {{ formatDate(item.end_date) }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click.stop="editPromoCode(item)">mdi-pencil</v-icon>
              <v-icon small @click.stop="removePromoCode(item)">mdi-delete</v-icon>
            </template>
          </v-data-table>
          <v-dialog v-model="showModal" max-width="500" persistent>
            <v-card>
              <v-card-title v-if="selectedPromoCode"> Edit Promo Code </v-card-title>
              <v-card-title v-else> Add Promo Code </v-card-title>
              <v-card-text>
                <v-text-field label="Promo Code" v-model="newPromoCode"></v-text-field>
                <label for="">start time</label>
                <flat-pickr class="flat-pickr-text-field" v-model="newStartDate" :config="datePickerConfig"></flat-pickr>
                <label for="">end time</label>
                <flat-pickr class="flat-pickr-text-field" v-model="newEndDate" :config="datePickerConfig"></flat-pickr>
                <v-text-field label="Enter Amount" v-model="newAmount"></v-text-field>
                <v-select v-if="selectedPromoCode"  v-model="newStatus" :items="items" label="Status"></v-select>
              </v-card-text>
              <v-card-actions>
                <v-btn color="primary" @click="selectedPromoCode ? updatePromoCode() : addPromoCode()">Add</v-btn>
                <v-btn @click="closeModal">Cancel</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import VueFlatpickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { PromoService } from "@/services";
import app from '@/main'

export default {
  components: {
    flatPickr: VueFlatpickr
  },
  data() {
    return {
      format: "Y-m-d H:i:S",
      items: ['active', 'inactive'],
      promoCodes: [],
      headers: [
        { text: "Promo Code", value: "code" },
        { text: "Start Date", value: "start_date" },
        { text: "End Date", value: "end_date" },
        { text: "status", value: "status" },
        {text:"beneficiary", value:"user.username"},
        { text: "Amount", value: "amount" },
        { text: "Actions", value: "actions", sortable: false }
      ],
      showModal: false,
      newPromoCode: "",
      newAmount: 0,
      newStatus: 'pending',
      startDatePicker: null,
      endDatePicker: null,
      newStartDate: new Date(),
      newEndDate: new Date(),
      selectedPromoCode: null,
      datePickerConfig: {
        enableTime: true, // Enable time selection
        dateFormat: "Y-m-d H:i:S",
        time_24hr: true,
        minuteIncrement: 1,
      }
    };
  },
  async mounted() {
    await this.retrieveAllPromoCode();
  },
  methods: {
    getChipColor(status) {
        if (status === 'active') {
            return 'green';
        } else if (status === 'pending') {
            return 'yellow';
        } else {
            return 'red';
        }
    },
    async retrieveAllPromoCode() {
      // app.$store.dispatch('toast', {
      //   message: 'loading promo codes...',
      //   variant: 'info'
      // });
      const promosResp = await PromoService.getAllPromo();

      if (promosResp) this.promoCodes = promosResp.data;
    },
    openStartDatePicker() {
      this.startDatePicker.open();
    },
    openEndDatePicker() {
      this.endDatePicker.open();
    },
    async addPromoCode() {
      app.$store.dispatch('toast', {
        message: 'uploading promo code...',
        variant: 'info'
      });
      const data = {
        code: this.newPromoCode,
        amount: this.newAmount,
        start_date: this.newStartDate.toLocaleString('en-CA', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
        }).replace(',', ''),
        end_date: this.newEndDate.toLocaleString('en-CA', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: 'numeric',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
        }).replace(',', ''),
        status: this.newStatus,
      };
      const promosResp = await PromoService.createPromoCode(data);
      if (promosResp) {
        await this.retrieveAllPromoCode();
        app.$store.dispatch('toast', {
          message: 'Promo code created successfully...',
          variant: 'success'
        });
      }
      await this.retrieveAllPromoCode();
      // this.promoCodes.push({
      //   code: this.newPromoCode,
      //   amount: this.newAmount,
      //   start_date: this.newStartDate,
      //   end_date: this.newEndDate,
      //   status: this.newStatus,
      //   id: this.promoCodes.length + 1
      // });
      this.newPromoCode = "";
      this.newAmount = 0;
      this.newStartDate = new Date();
      this.newEndDate = new Date();
      this.showModal = false;
    },
    editPromoCode(promoCode) {
    
      this.selectedPromoCode = promoCode.id;
      this.newPromoCode = promoCode.code;
      this.newStartDate = promoCode.start_date;
      this.newEndDate = promoCode.end_date;
      this.newStatus = promoCode.status;
      this.newAmount = promoCode.amount;
      this.showModal = true;
    },
    async updatePromoCode() {
      // app.$store.dispatch('toast', {
      //   message: 'updating promo code...',
      //   variant: 'info'
      // });
      // this.selectedPromoCode.code = this.newPromoCode;
      // this.selectedPromoCode.start_date = this.newStartDate;
      // this.selectedPromoCode.end_date = this.newEndDate;
      // this.selectedPromoCode.amount = this.newAmount;
      // this.selectedPromoCode.status = this.newStatus;
      const data = {
        id: this.selectedPromoCode,
        code: this.newPromoCode,
        amount: this.newAmount,
        start_date: this.newStartDate,
        end_date: this.newEndDate,
        status: this.newStatus,
      };
      const promosResp = await PromoService.editPromoCode(data);
      if (promosResp) {
        app.$store.dispatch('toast', {
          message: 'Promo code created successfully...',
          variant: 'success'
        });
      }
      await this.retrieveAllPromoCode();
      this.selectedPromoCode = null;
      this.newPromoCode = "";
      this.newStartDate = new Date();
      this.newEndDate = new Date();
       this.newAmount = 0;
      this.showModal = false;
    },
    removePromoCode(promoCode) {
      this.promoCodes = this.promoCodes.filter(p => p !== promoCode);
    },
    closeModal() {
      this.showModal = false;
      this.newPromoCode = "";
      this.newAmount = 0;
      this.newStartDate = new Date();
      this.newEndDate = new Date();
      this.selectedPromoCode = null;
    },
    formatDate(date) {
      const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false, // Use 24-hour format
      };
      return new Date(date).toLocaleString(undefined, options);
    }

  }
};
</script>

<style scoped>
.flat-pickr-text-field {
  border: 1px solid #ccc;
  padding: 8px;
  border-radius: 4px;
  cursor: pointer;
  width: 100%;
}
</style>
